<template>
  <v-app id="app" data-app="true" :key="language">
    <Alerts />
    <OrgSwitchPromptDialog data-testid="app-dialog-orgSwitchPrompt" />
    <OrgSwitchLoadingScreen data-testid="app-screen-orgSwitchLoading" />
    <BlankLayout v-if="layout === $constants.layouts.blank" />
    <DefaultLayout v-else />
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import mixin from '@/mixins/mixin.vue'
import authMixin from '@/mixins/authMixin.vue'
import Azure from '@/lib/Azure'

import Alerts from '@/components/Notifications/Alerts.vue'

import DefaultLayout from './DefaultLayout.vue'
import BlankLayout from './BlankLayout.vue'
import OrgSwitchLoadingScreen from './OrgSwitchLoadingScreen.vue'
import OrgSwitchPromptDialog from './OrgSwitchPromptDialog.vue'
import _ from 'lodash'

export default {
  name: 'app',

  components: {
    Alerts,
    DefaultLayout,
    BlankLayout,
    OrgSwitchLoadingScreen,
    OrgSwitchPromptDialog,
  },

  mixins: [mixin, authMixin],


  methods: {
    isWhitelistedRoute(route) {
      const whitelistedRoutes = _.compact([
        '/access/google',
        '/access/microsoft',
        '/access/microsoft-start',
        '/access/saml',
        '/download',
        '/help',
        '/register',
        '/reset-password',
        '/reset-password/:token',
        !this.$isFeatureEnabled(this.$featuresKeys?.disableSignupRoute) &&
          '/signup',
      ])

      return whitelistedRoutes.includes(route)
    },
  },

  computed: {
    ...mapState({
      isLoggedIn: state => Boolean(state.access?.token),
    }),

    ...mapGetters(['language']),

    isDowntimeMigrationEnabled() {
      return this.$isFeatureEnabled(this.$featuresKeys?.downtimeMigration)
    },

    layout() {
      return this.$route?.meta?.layout ?? this.$constants?.layouts?.default
    },
  },

  mounted() {
    this.$configureTracking()

    Azure.startTokensRefreshingProcess({
      store: this.$store,
      router: this.$root.$router,
      translator: this.$t.bind(this),
    })
  },

  created() {
    if (this.isDowntimeMigrationEnabled)
      return this.$router
        .push({
          name: 'downtime',
          query: { redirect: this.$route.fullPath },
        })
        .catch(err => console.log(err))

    if (
      !this.isLoggedIn &&
      !this.isWhitelistedRoute(this.$route.matched[0]?.path)
    ) {
      if (this.$route.name === 'access') return

      this.$router
        .push({ name: 'access', query: { redirect: this.$route.fullPath } })
        .catch(err => console.log(err))
    }
  },
}
</script>

<style lang="scss">
@import '../styles/main.scss';
</style>
